{
    "rapormusteridetay": {
        "Baslik": "Klant Detail Rapport",
        "ID": "#",
        "Musteri": "Klant",
        "Referans": "Referentie",
        "Kullanici": "Gebruiker",
        "Randevu": "R",
        "SatisOnayli": "G",
        "SatisOnaysiz": "N",
        "SatisIptal": "A",
        "SatisCayma": "O",
        "UrunSayisi": "A",
        "UrunSayisiTam": "Product Aantal",
        "Olusturan": "Gemaakt door",
        "Olusturma": "Gemaakt op",
        "Ad": "Voornaam",
        "Soyad": "Achternaam",
        "Cep": "Mobiel",
        "ExcelAktar": "Excel Exporteren",
        "Ara": "Zoeken",
        "MusteriDetay": "Klant Detail",
        "Bilgisi": "Informatie",
        "Randevular": "Afspraken",
        "Satislar": "Verkopen",
        "Loglar": "Logs",
        "Aktarma": "Overdracht",
        "GeciciYetki": "Tijdelijke Machtiging",
        "Tasi": "Verplaatsen",
        "Guncelle": "Bijwerken",
        "Kapat": "Sluiten",
        "Tarih": "Datum",
        "Saat": "Tijd",
        "Gorusme": "Contact",
        "Ulasim": "Vervoer",
        "Sonuc": "Resultaat",
        "Aciklama": "Beschrijving",
        "SigortaEttiren": "Verzekeringnemer",
        "Urun": "Product",
        "PoliceNo": "Polisnummer",
        "TutarTL": "Bedrag (₺)",
        "TutarDolar": "Bedrag ($)",
        "Kur": "Koers",
        "Ape": "Ape",
        "Not": "Notitie",
        "Durum": "Status",
        "Filtrele": "Filteren",
        "MusteriBilgileri": "Klantinformatie",
        "KendiKayitlarim": "Mijn Records",
        "TakimKayitlarim": "Team Records",
        "SubeKayitlarim": "Filiaal Records",
        "TumKayitlar": "Alle Records",
        "Gorunum": "Weergave",
        "MusteriAdSoyad": "Klantnaam / Achternaam",
        "Takim": "Team",
        "Sube": "Filiaal",
        "OlusturmaBaslangic": "Aanma Begindatum",
        "OlusturmaBitis": "Aanma Einddatum",
        "SatisBilgileri": "Verkoop-informatie",
        "OnayliSatisFiltresi": "Goedgekeurde Verkoop Filter",
        "Kriter": "Criterium",
        "Deger": "Waarde",
        "UrunSecimi": "Product Selectie",
        "SatisBaslangic": "Verkoop Begindatum",
        "SatisBitis": "Verkoop Einddatum",
        "RandevuBilgileri": "Afspraak-informatie",
        "RandevuFiltresi": "Afspraak Filter",
        "RandevuBaslangic": "Afspraak Begindatum",
        "RandevuBitis": "Afspraak Einddatum",
        "Sifirla": "Resetten",
        "RandevuSayisi": "Aantal Afspraken",
        "OnaysizSatis": "Niet-goedgekeurde Verkoop",
        "OnayliSatis": "Goedgekeurde Verkoop",
        "IptalSatis": "Geannuleerde Verkoop",
        "CaymaSatis": "Herroepen Verkoop",
        "Esittir": "Gelijk aan (=)",
        "BuyukEsittir": "Groter dan of gelijk aan (>=)",
        "Kucuk": "Kleiner dan (<)",
        "KucukEsittir": "Kleiner dan of gelijk aan (<=)"
    }
}
